import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BathBathroom, Bed, Pet, UserCouple, } from '@awaze/design-system.components.icon';
import { Stack } from '@awaze/design-system.components.stack';
import { Text } from '@awaze/design-system.components.text';
import { getPluralString, pxToRems } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
const SpecListItem = styled.li `
  display: flex;
  align-items: center;
  gap: ${pxToRems(8)};
`;
const StyledVisuallyHiddenLabel = styled.span `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
export const SpecItem = ({ icon, value, label }) => value !== undefined &&
    value !== null && (_jsxs(SpecListItem, { children: [label !== 'Studio' ? (_jsx(StyledVisuallyHiddenLabel, { children: label })) : null, icon, _jsx("span", { "aria-hidden": "true", children: _jsx(Text, { sizes: 200, children: value }) })] }));
export const defaultTranslations = {
    guests: 'Sleeps up to',
    studio: 'Studio',
    bedrooms: { singular: 'bedroom', plural: 'bedrooms' },
    bathrooms: { singular: 'bathroom', plural: 'bathrooms' },
    pets: {
        label: 'Up to',
        singular: 'pet',
        plural: 'pets',
        allowed: 'allowed',
    },
};
/**
 * A component that displays property specifications as numbers (guests, bathrooms, bedrooms, pets).
 */
export function PropertySpecs({ guests, bedrooms, bathrooms, pets, translations = defaultTranslations, }) {
    const getLabelStrings = (type) => {
        switch (type) {
            case 'guests':
                return `${translations.guests} ${guests}`;
            case 'bedrooms':
                if (bedrooms === 0) {
                    return translations.studio;
                }
                return `${bedrooms} ${getPluralString(bedrooms, translations.bedrooms.singular, translations.bedrooms.plural)}`;
            case 'bathrooms':
                return `${bathrooms} ${getPluralString(bathrooms, translations.bathrooms.singular, translations.bathrooms.plural)}`;
            case 'pets':
                return `${translations.pets.label} ${pets} ${getPluralString(pets, translations.pets.singular, translations.pets.plural)} ${translations.pets.allowed}`;
            default:
                return '';
        }
    };
    return (_jsxs(Stack, { direction: "row", as: "ul", spacing: 12, children: [_jsx(SpecItem, { label: getLabelStrings('guests'), icon: _jsx(UserCouple, { iconColour: "ColorGrey400", size: "small" }), value: guests }), _jsx(SpecItem, { label: getLabelStrings('bedrooms'), icon: _jsx(Bed, { iconColour: "ColorGrey400", size: "small" }), value: bedrooms === 0 ? translations.studio : bedrooms }), _jsx(SpecItem, { label: getLabelStrings('bathrooms'), icon: _jsx(BathBathroom, { iconColour: "ColorGrey400", size: "small" }), value: bathrooms }), _jsx(SpecItem, { label: getLabelStrings('pets'), icon: _jsx(Pet, { iconColour: "ColorGrey400", size: "small" }), value: pets })] }));
}
//# sourceMappingURL=property-specs.js.map